<template>
<div class="stage">
  <main>
    <div class="">

      <div class="position-relative">
        <section class="story-banner">
          <stage-banner :title="title"></stage-banner>
        </section>

        <section class="story" id="story">
          <div class="container">

            <div class="story-content">

              <div>
                <b-button v-b-modal.chapterselect variant="light" size="sm" class="mb-3 py-0 px-2">
                  <span class="font-weight-bold">章節選擇</span>
                </b-button>
              </div>

              <!-- 要改的內容 -->
              <npc :npc-id="1" right>說起來，呂善安，你知道賴和是怎麼看待『迷信』這件事的嗎？</npc>
              <npc :npc-id="0">怎麼啦？為什麼這麼問？</npc>
              <npc :npc-id="1" right>是延續之前的『新式教育知識分子』的問題啦。現在也是吧，對鬼神、民間信仰之類的，受過現代教育的人們，都覺得不值一提吧？接受漢學是一回事，但賴和讀過醫學院，是怎麼看到臺灣傳統信仰的呢？</npc>
              <npc :npc-id="0">你問的這問題還真難啊！但在我看來，賴和先生應該是不排斥民間信仰的。</npc>
              <npc :npc-id="1" right>怎麼說？</npc>
              <npc :npc-id="0">日治時代，李獻璋編了一本《臺灣民間文學集》，這本書是賴和先生出資讓李獻璋編的，還找了知名畫家陳澄波畫封面；雖然編這本書花了很多時間，賴和先生還是持續資助他，完成這本書。</npc>
              <npc :npc-id="1" right>啊，我知道《臺灣民間文學集》，原來背後有這樣的故事啊！</npc>
              <npc :npc-id="0">不只如此，賴和先生還寫過〈就迷信而言〉這篇文章，說迷信是該破除，但破除得太早，宗教活動看起來是變少了，其實早就沒有在敬神拜佛，而是以振興市場為目的；在我看來，賴和先生對民間信仰是懷著善意的。</npc>
              <npc :npc-id="1" right>真不可思議。明明受過新式教育，居然不急著破除迷信嗎？</npc>
              <npc :npc-id="0">不如說，如果受過新式教育就非得反對傳統，那不就只是為反而反嗎？賴和先生不過是找到了調和新與舊的方法——</npc>
              <npc :npc-id="1" right>啊！呂善安，你看！孔廟的門上！</npc>

              <story-image :src="require(`@/assets/images/pics/第3章_2-1_門.jpg`)" size="lg"></story-image>
              <!-- （圖片，孔廟門上插著小刀，穿刺幾張紙） -->

              <npc :npc-id="0">怪盜也太囂張了吧！這可是孔廟的門耶！就算可以修也是要錢的！</npc>
              <npc :npc-id="1" right>感謝你為公部門著想，但現在重點在紙上的內容吧？也是謎題嗎？</npc>
              <npc :npc-id="0">我打開看看。</npc>

              <story-image :src="require(`@/assets/images/pics/第3章_2-2_孔廟謎題圖_1.jpg`)" size="lg"></story-image>
              <story-image :src="require(`@/assets/images/pics/第3章_2-3_孔廟謎題圖_2.jpg`)" size="lg"></story-image>
              <story-image :src="require(`@/assets/images/pics/第3章_2-4_孔廟謎題圖_3.jpg`)" size="lg"></story-image>
              <!-- （圖） -->
              <!-- （圖） -->
              <!-- （圖） -->

              <npc :npc-id="0">原來如此，看來是謎題沒錯。</npc>
              <npc :npc-id="1" right>這個要怎麼解？</npc>
              <npc :npc-id="0">我想想，現在我應該——</npc>

              <div class="row my-3" v-if="sp_select !== 1">
                <div class="col-12 col-md mb-3">
                  <button class="btn btn-block btn-outline-light" @click="spSelect(1)">
                    疊圖
                  </button>
                </div>

                <div class="col-12 col-md mb-3">
                  <button class="btn btn-block btn-outline-light" @click="spSelect(2)">
                    摺紙
                  </button>
                </div>

                <div class="col-12 col-md mb-3">
                  <button class="btn btn-block btn-outline-light" @click="spSelect(3)">
                    用刀割開
                  </button>
                </div>

                <b-modal id="contenthint" hide-footer title="提示">
                  <div>
                    <p>半透明那張紙上的圖案，好像也出現在另外兩張紙上欸。</p>
                  </div>
                </b-modal>

                <div class="col-12 mt-2 text-center">
                  <b-button v-b-modal.contenthint variant="light">
                    <span>
                      <font-awesome-icon :icon="['fa', 'lightbulb']" fixed-width/>
                      提示
                    </span>
                  </b-button>
                </div>
              </div>

              <div v-if="sp_select !== -1 && sp_select !== 1">
                <npc :npc-id="0">嗯，好像不太對呢。</npc>
                <npc :npc-id="1" right>好像不太對呢。</npc>
                <npc :npc-id="0">再重新想看看吧？</npc>
              </div>

              <div v-if="sp_select === 1">
                <p class="m-0 py-5 text-center">(呂善安與助手將幾張圖疊了起來)</p>
                <story-image :src="require(`@/assets/images/pics/第3章_3-1_孔廟謎題圖_疊圖1.jpg`)" size="lg"></story-image>
                <story-image :src="require(`@/assets/images/pics/第3章_3-2_孔廟謎題圖_疊圖2.jpg`)" size="lg"></story-image>
                <npc :npc-id="0">原來如此⋯⋯看來這個黑色條狀會指出題目呢。『此處碑文之數』跟『阿█』嗎？</npc>
                <npc :npc-id="1" right>也就是數碑文的數目吧？交給我吧！</npc>
                <npc :npc-id="0">嗯，就交給你了。</npc>
              </div>
              <!-- 要改的內容到此 -->

            </div>

          </div>
        </section>

        <section class="question" v-if="sp_select === 1">
          <div class="container">

            <!-- 要改的內容 -->
            <question-part hint="門口區域這邊，除了門旁邊的石碑以外，走下台階，在牆旁邊也還可以看到其他碑喔。(「彰化孔子廟」的碑不算) ">
              <p>此處石碑的數量？答案是中文字（例：一、二、三……）。</p>
            </question-part>
            <!-- 要改的內容到此 -->

          </div>
        </section>

      </div>


      <div class="top-level">
        <top-bottom-button :question="isQuestion"></top-bottom-button>

        <b-modal id="chapterselect" hide-footer title="選擇章節">
          <chapter-select :now-stage="stageId"></chapter-select>
        </b-modal>
      </div>

    </div>
  </main>
</div>
</template>

<script>
// import Cookie from '@/utilities/Cookie.js'
import StageBanner from '@/components/StageBanner.vue'
import TopBottomButton from '@/components/TopBottomButton.vue'
import ChapterSelect from '@/components/ChapterSelect.vue'
import '@/assets/css/stage.css'

export default {
  name: 'Stage3_2',
  components: {
    StageBanner,
    TopBottomButton,
    ChapterSelect,
  },
  props: {},
  data() {
    return {
      title: '第三章 - 2',
      isQuestion: true,
      stageId: 'tale',

      sp_select: -1,
    };
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  methods: {
    spSelect: function(s) {
      this.sp_select = s;
    }
  }
}
</script>

<style scoped>

</style>
